import { Icon } from '../../layouts'

export default function Arrow() {
    return (
        <Icon viewBox="0 0 81 80">
            <path d="M41.038,0l-4.484,4.388l32.029,32.062l-68.583,0l0,6.25l68.583,0l-32.025,32.083l4.48,4.384l39.52,-39.584l-39.52,-39.583Z" />
        </Icon>
    )
}
